import { useEffect } from "react";
import { YearlyReportsTable } from "./YearlyReportsBody";

import { useQueries } from "@hooks/useQueries";
import { TableFilter } from "./YearlyReportsBody/ReportFilter";
import { ReportType } from "@hooks/HRM/reports/useYearlyReports";

export const YearlyReports = ({
  handleQuery,
  reportData,
  selectedReport,
  selectedData,
  date,
}: {
  handleQuery: (key: string, value: number | string) => void;
  selectedData: (id: number) => void;
  date: number;
  reportData: any[];
  selectedReport: ReportType | undefined;
}) => {
  const { setSearchParams } = useQueries();

  useEffect(() => {
    setSearchParams(undefined);
  }, []);

  return (
    <div className="pt-10">
      <TableFilter
        handleQuery={handleQuery}
        selectedData={selectedData}
        year={date}
      />
      <YearlyReportsTable
        column={selectedReport?.column || []}
        rows={reportData || []}
      />
    </div>
  );
};
